import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import pageSucess from '../views/pageSucess.vue'
import pagemExistente from '../views/pageExistente.vue'
import pagemExistente2 from '../views/pageExistente2.vue'
import Table from "../views/Table.vue"
import Form from "../views/FormView.vue"

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/pageSucess',
    name: 'pageSucess',
    component: pageSucess
  },
  {
    path: '/pageExistente2',
    name: 'pageExistente2',
    component: pagemExistente2
  },
  {
    path: '/pageExistente',
    name: 'pageExistente',
    component: pagemExistente
  },
  {
    path: '/table',
    name: 'Table',
    component: Table
  },
  {
    path: '/form',
    name: 'Form',
    component: Form
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return window.scrollTo({ top: 0 })
  }
})

export default router
